module.exports = {
      id: "taurus-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#taurus",
      toString: function () {
        return this.url;
      }
    }